jQuery(document).ready(function(){
  jQuery('.a_chb').click(function(){
    jQuery('body').addClass('hideheaderblock');
  });
  jQuery("body").each(function() {
		  setInterval(function(){
           var el = $('.zakeke-product-button-container');
            var index = 0;
             var timer = window.setInterval(function(){
               if  (index < el.length) {
                el.eq(index++).parents('body').addClass('cstbtnbdy');
             } else {
                 window.clearInterval(timer);
              }
              }, 1000);
		  }, 1);	
});
//   jQuery(window).load(function() {
//     setTimeout(function(){
// 		$('.product-form__buttons .product-form__submit').addClass('showbtn');
//       },2000);
// });
   var divCount = jQuery('variant-selects').find(".product-form__input--dropdown").length;
  jQuery('.product .product__info-wrapper').addClass('ttstp' + divCount);
});
